import { TOKEN } from "~/constants/storage";

export const getToken = () => {
  return sessionStorage.getItem(TOKEN) || "";
};
